import React from 'react';
import { ComponentProps } from 'types/index';
import classNames from 'classnames';
import { useProgressCalculation } from 'lib/hooks/useProgressCalculation';
import { rem } from 'lib/utils/util';
import './index.scss';

interface Props {
  backgroundImage: string;
  progressBarImage: string;
  step: number;
  stages: { step: number; text: string }[];
}

export default function ProgressBar({ data, commonStyle, style }: ComponentProps<Props>) {
  const { backgroundImage, progressBarImage, step, stages } = data;
  const { textColor, textFontSize } = style;
  const progress = useProgressCalculation(step);
  const progressPercent = (progress / step) * 100;

  return (
    <div className="progress-bar-v2-wrapper" style={{ ...commonStyle }}>
      <img className="progress-bar-v2__backgroud-img" alt="" src={backgroundImage} />
      <div className="progress-bar-v2__container">
        <img
          className="progress-bar-v2__img"
          src={progressBarImage}
          style={{
            left: `${-100 + progressPercent}%`,
          }}
        />
      </div>
      {stages?.map((item) => {
        const positionPercent = (item?.step / step) * 100;
        return (
          <div
            key={item?.step}
            className="progress-bar-v2__stage"
            style={{ color: textColor, fontSize: rem(textFontSize), left: `${positionPercent}%` }}
          >
            <div
              className={classNames('progress-bar-v2__stage-text', {
                first: item?.step === 0,
              })}
            >
              {item?.text}
            </div>
          </div>
        );
      })}
    </div>
  );
}
